import React, { useState } from "react";
import axios from "axios";
import { decryptToken } from "../utils/getToken";

const QuestionForm = ({ faqId, refresh }) => {
    const [ques, setQues] = useState("");
    const [ans, setAns] = useState("");
    const API = process.env.REACT_APP_LINK
    const token = decryptToken("accessToken") || ""

    const submit = async () => {
        if (!ques || !ans) return alert("All fields required");
        await axios.post(`${API}/faqques`, {
            faq_id: faqId,
            ques,
            ans
        },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
        setQues("");
        setAns("");
        refresh();
    };

    return (
        <div className="faq-question-form">
            <input
                placeholder="Question"
                value={ques}
                onChange={(e) => setQues(e.target.value)}
            />
            <textarea
                placeholder="Answer"
                value={ans}
                onChange={(e) => setAns(e.target.value)}
            />
            <button onClick={submit}>Add Question</button>
        </div>
    );
};

export default QuestionForm;
